import React from 'react';
import PropTypes from 'prop-types';
import Cross from '@deliveroo/icon-set/react/Cross';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import Button from '@deliveroo/consumer-component-library/components/Button';

import styles from './MobileBanner.scss';

/**
 * A generic, dismissable banner to display at the top of the viewport on mobile
 */
export default class MobileBanner extends React.Component {
  container = null;

  componentDidMount() {
    if (this.container) {
      this.setState({ height: this.container.clientHeight });
    }
  }

  getStyle() {
    if (this.container) {
      const { isDismissed } = this.props;
      const { height } = this.state;

      if (isDismissed) {
        return {
          marginTop: `-${height}px`,
        };
      }
    }

    return undefined;
  }

  render() {
    const {
      buttonText,
      buttonLink,
      renderWrapper,
      renderImage,
      renderBody,
      onClose,
      onButtonClick,
    } = this.props;

    return (
      <div
        ref={(el) => {
          this.container = el;
        }}
        style={this.getStyle()}
        className={styles.banner}
      >
        {renderWrapper(
          <div className={styles.content}>
            <button type="button" className={styles.dismiss} onClick={onClose}>
              <Icon component={Cross} color="white" size={18} />
            </button>
            {renderImage && <div className={styles.image}>{renderImage()}</div>}
            <div className={styles.body}>{renderBody()}</div>
            {buttonText && (
              <div className={styles.button}>
                <Button href={buttonLink} onClick={onButtonClick} size="small">
                  {buttonText}
                </Button>
              </div>
            )}
          </div>,
        )}
      </div>
    );
  }
}

MobileBanner.propTypes = {
  /**
   * Is the banner dismissed?
   */
  isDismissed: PropTypes.bool.isRequired,

  /**
   * Text to display inside the main CTA button. If not supplied, no button is rendered.
   */
  buttonText: PropTypes.string,

  /**
   * Link href for the main CTA button.
   */
  buttonLink: PropTypes.string,

  /**
   * A render prop to wrap the contents of the banner. This can be used to
   * for e.g. apply a background image to the banner.
   */
  renderWrapper: PropTypes.func,

  /**
   * A render prop for the image section of the banner contents.
   */
  renderImage: PropTypes.func,

  /**
   * A render prop for the body of the banner.
   */
  renderBody: PropTypes.func.isRequired,

  /**
   * Event handler for when the banner is closed.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Event handler for when the main CTA button is clicked.
   */
  onButtonClick: PropTypes.func,
};

MobileBanner.defaultProps = {
  buttonText: undefined,
  buttonLink: undefined,
  renderWrapper: (children) => <div className={styles.wrapper}>{children}</div>,
  renderImage: undefined,
  onButtonClick: () => undefined,
};
